import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash";
import * as angular from "angular";
import {SplitService} from "../../../commons/services/split-service.service";
import {DataSet} from "vis-data";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";

export class ItinerariesTimelineCtrl implements IController {
  from: any;
  to: any;
  itineraries: any;
  tasks: any;
  agentsGroup: any;
  selectedItemId: any;
  highlightedItemId: any;
  canEdit: any;
  doFit: any;
  onTaskSelection: Function;
  onTaskHighlight: Function;
  onTaskRightClick: Function;
  onChangeItinerary: Function;
  onAgentsGroupChange: Function;


  private readonly vis: any;
  private readonly dateAndTimeConfig: any;
  private readonly timeFormat: any;
  private readonly shortDateFormat: any;
  private readonly longDateFormat: any;
  private readonly INTERNAL_TASK_PURPOSE: any;
  private readonly TASK_PURPOSE_TO_COLOR_MAP: any;

  private container: any;
  private timeline: any;
  private options: any;
  private groupsDataSet: any;
  private itemsDataSet: any;
  private tableHeaderDivRef: any;
  private movedItemOriginalData: any;

  /* @ngInject */
  constructor(private $q: IQService, private $filter, private $timeout: ITimeoutService, private tasksConstants,
              private splitService: SplitService,
              private bringozTimelineService: BringozTimelineService, private moment) {

    this.vis = require('vis-timeline');
    this.dateAndTimeConfig = this.splitService.getDateAndTimeConfig();
    this.timeFormat = this.dateAndTimeConfig.time;
    this.shortDateFormat = this.dateAndTimeConfig.date;
    this.longDateFormat = this.dateAndTimeConfig.long;
    this.INTERNAL_TASK_PURPOSE = this.tasksConstants.internalTaskTypes;
    this.TASK_PURPOSE_TO_COLOR_MAP = this.tasksConstants.purposeToColor;
  }

  $onInit() {
    // Check permissions to update roues
    if (_.isUndefined(this.canEdit)) {
      this.canEdit = false;
    }

    // Create Main Container
    this.container = document.getElementById('timeline');

    this.groupsDataSet = new DataSet()
    this.itemsDataSet = new DataSet()

    // Set Options
    this.options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      // groupOrder: function (a, b) {
      //     return a.value - b.value;
      // },
      groupOrderSwap: (groupDragged, groupToSwap, groups) => {
        const value = groupDragged.value;
        groupDragged.value = groupToSwap.value;
        groupToSwap.value = value;
      },
      groupTemplate: (group) => {

        if (!group) {
          return null;
        }

        const container = document.createElement('div');
        container.classList.add("agent-details-container");

        const imageContainer = document.createElement('div');
        imageContainer.classList.add("image-container");

        if (group.imageUrl) {
          const agentImage = document.createElement("IMG");
          agentImage.setAttribute("src", group.imageUrl);
          imageContainer.insertAdjacentElement('beforeend', agentImage);
        } else {
          const imageDiv = document.createElement('div');
          imageDiv.classList.add("agent-image-initials-div");
          const imageSpan = document.createElement("span");
          imageSpan.innerText = group.nameInitials;
          imageDiv.insertAdjacentElement('beforeend', imageSpan);
          imageContainer.insertAdjacentElement('beforeend', imageDiv);
        }

        const agentTasksCountContainer = document.createElement('div');
        agentTasksCountContainer.classList.add("agent-task-count-container");

        const tasksCount = document.createElement('span');
        tasksCount.textContent = _.get(group, 'taskIdList.length', 0);
        agentTasksCountContainer.insertAdjacentElement('beforeend', tasksCount);
        imageContainer.insertAdjacentElement('beforeend', agentTasksCountContainer);


        const infoDiv = document.createElement('div');
        infoDiv.classList.add("agent-info-container");

        const agentNameRow = document.createElement('div');
        agentNameRow.classList.add("info-row");

        const agentTypeRow = document.createElement('div');
        agentTypeRow.classList.add("info-row");

        const agentIndicationsRow = document.createElement('div');
        agentIndicationsRow.classList.add("info-row");

        const agentName = document.createElement('span');
        agentName.classList.add("br-body-1", "font-weight-600");
        agentName.innerText = group.name;
        agentNameRow.insertAdjacentElement('beforeend', agentName);

        const agentType = document.createElement('span');
        agentType.classList.add('br-body-1');
        agentType.textContent = this.$filter('translate')(group.agentType);
        agentTypeRow.insertAdjacentElement('beforeend', agentType);

        infoDiv.insertAdjacentElement('beforeend', agentNameRow);
        infoDiv.insertAdjacentElement('beforeend', agentTypeRow);
        infoDiv.insertAdjacentElement('beforeend', agentIndicationsRow);

        container.insertAdjacentElement('beforeend', imageContainer);
        container.insertAdjacentElement('beforeend', infoDiv);

        return container;
      },
      // onMoving: (item, callback) => {
      //   if (item.stopId) {
      //     if (_.isUndefined(this.movedItemOriginalData)) {
      //       var orderedItems = this.timeline.components[3].groups[item.group].orderedItems.byStart;
      //       this.movedItemOriginalData = {
      //         group: item.group,
      //         index: _.findIndex(orderedItems, (orderedItem: any) => {
      //           return orderedItem.data.activityId === item.activityId;
      //         })
      //       }
      //     }
      //     callback(item); // updating the item
      //   } else {
      //     callback(null); // cancel updating the item
      //   }
      // },
      // onMove: (item, callback) => {
      //   var fromRouteId = item.routeId;
      //   var toRouteId = item.group;
      //
      //   callback(item);
      //   var canMove = this._canItemMove(item);
      //
      //   if (!canMove) {
      //     callback(null);
      //     return;
      //   }
      //
      //   var groupsMap = this.timeline.components[3].groups;
      //   var isBetweenRoutes = fromRouteId !== toRouteId;
      //
      //   this.movedItemOriginalData = undefined;
      //
      //   this.onMoveItem(
      //     {
      //       jobIds: item.jobIds,
      //       fromRouteId: fromRouteId,
      //       toRouteId: toRouteId,
      //       fromOrderedIds: _.chain(
      //         groupsMap[fromRouteId].orderedItems.byStart)
      //         .filter(function (item) {
      //           return _.isEqual(item.data.activityType, 'STOP');
      //         })
      //         .map(function (filteredItem) {
      //           return filteredItem.data.stopId;
      //         })
      //         .value(),
      //       toOrderedIds: isBetweenRoutes ?
      //         _.chain(
      //           groupsMap[toRouteId].orderedItems.byStart)
      //           .filter(function (item) {
      //             return _.isEqual(item.data.activityType,
      //               'STOP');
      //           })
      //           .map(function (filteredItem) {
      //             return filteredItem.data.stopId;
      //           })
      //           .value() : undefined
      //     }
      //   );
      //   ctrl.movingItem = undefined;
      // },
      snap: (date, scale, step) => {
        const minute = 60 * 1000;
        return Math.round(date / minute) * minute;
      },
      // onAdd: (data, callback) => {
      //   if (!data.items || !data.items.length) {
      //     callback(null);
      //     return;
      //   }
      //
      //   const canAdd = this._canLeftoversAddToRoute(data.items, data.group);
      //
      //   if (!canAdd) {
      //     callback(null);
      //     return;
      //   }
      //
      //   var route = _.find(this.routes, (r) => {
      //     return r.id === data.group;
      //   });
      //
      //   var index;
      //   var order = [];
      //
      //   _.forEach(route.activities, function (a, i) {
      //     if (a.eta < data.start.valueOf()) {
      //       index = i + 1;
      //     }
      //     if (_.isEqual(a.type, 'STOP')) {
      //       order.push(a.stopId);
      //     }
      //     if (_.isEqual(a.type, 'GROUP')) {
      //       order = order.concat(a.stopIds);
      //     }
      //   });
      //   if (index) {
      //     var stopIds = [];
      //     var jobIds = [];
      //     _.forEach(data.items, function (i) {
      //       stopIds = stopIds.concat(i.stopIds);
      //       jobIds = jobIds.concat(i.jobIds)
      //     });
      //
      //     _.forEach(stopIds, function (id, i) {
      //       order.splice(index + i, 0, id);
      //     });
      //     ctrl.onAddStopsToRoute({routeId: data.group, jobIds: jobIds, order: order})
      //   }
      //   callback(null);
      // },
      orientation: 'top',
      // editable: true,
      // selectable: true,
      format: {
        minorLabels: {
          minute: this.timeFormat,
          hour: this.timeFormat,
          weekday: this.longDateFormat,
          day: this.shortDateFormat
        }
      },
      editable: {
        add: this.canEdit,                // add new items by double tapping
        updateTime: this.canEdit,        // drag items horizontally
        updateGroup: false,             // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: true           // allow these options to override item.editable
      },
      groupEditable: this.canEdit,
      verticalScroll: true,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      margin: {
        item: 5
      },
      stack: false,
      showTooltips: true,
      tooltip: {
        followMouse: true
      },
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      start: this.from ? this.moment(this.from) : this.moment().startOf('month'),
      end: this.to ? this.moment(this.to) : this.moment().endOf('month'),
      // min: ctrl.from ? moment(ctrl.from).subtract(2, 'day') : moment().startOf('month'),
      // max: ctrl.to ? moment(ctrl.to).add(2, 'day') : moment().endOf('month'),
      zoomMin: 1080000 // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
    };

    // Set Timeline
    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    // Set Table Header Element
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';

    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("table-header-container");
    topElementRef.before(this.tableHeaderDivRef);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Init Groups/Items Data

    if (_.get(this.itineraries, 'length')) {
      this._addItinerariesToTimeline(this.itineraries);
    }
    // _initTimelineData(ctrl.itinerary, ctrl.tasks, ctrl.relatedItineraries, ctrl.relatedTasks);

    this._initTimelineEventListeners();
  }

  $onChanges(changes) {
    if (changes.itineraries && !changes.itineraries.isFirstChange()) {

      const currentItineraries = changes.itineraries.currentValue || [];
      const previousItineraries = changes.itineraries.previousValue || [];

      const itinerariesToAdd = _.differenceBy(currentItineraries, previousItineraries, 'id');
      const itinerariesToRemove = _.differenceBy(previousItineraries, currentItineraries, 'id');

      const currentUpdatedItineraries = _.differenceBy(currentItineraries, itinerariesToAdd, 'id');
      const previousUpdatedItineraries = _.differenceBy(previousItineraries, itinerariesToRemove, 'id');

      const currentItinerariesToUpdate = _.filter(currentUpdatedItineraries, function (currentUpdatedItinerary: any) {
        const previousUpdatedItinerary: any = _.find(previousUpdatedItineraries, ['id', currentUpdatedItinerary.id]);
        // Check if itinerary was changed
        return previousUpdatedItinerary.analysisTime < currentUpdatedItinerary.analysisTime;
      });

      const previousItinerariesToUpdate = _.filter(previousUpdatedItineraries, function (previousUpdatedItinerary: any) {
        const currentUpdatedItinerary: any = _.find(currentUpdatedItineraries, ['id', previousUpdatedItinerary.id]);
        // Check if itinerary was changed
        return previousUpdatedItinerary.analysisTime < currentUpdatedItinerary.analysisTime;
      });

      // Remove groups and items
      const taskIdsToRemove = _.flatMap(_.concat(itinerariesToRemove, previousItinerariesToUpdate), 'taskIdListExt');
      const backgroundItemIdsToRemove = _.map(_.concat(itinerariesToRemove, previousItinerariesToUpdate), 'id');
      // var itineraryIdsToRemove = _.map(_.concat(itinerariesToRemove, previousItinerariesToUpdate), 'id');
      const itineraryIdsToRemove = _.map(_.concat(itinerariesToRemove), 'id');

      if (_.get(itineraryIdsToRemove, 'length')) {
        this.groupsDataSet.remove(itineraryIdsToRemove);
      }
      if (_.get(taskIdsToRemove, 'length') || _.get(backgroundItemIdsToRemove, 'length')) {
        this.itemsDataSet.remove(_.concat(taskIdsToRemove, backgroundItemIdsToRemove));
      }
      this._addItinerariesTasksToTimeline(currentItinerariesToUpdate);


      this._addItinerariesToTimeline(itinerariesToAdd);
      // _addItinerariesToTimeline(itinerariesToAdd.concat(currentItinerariesToUpdate));
    }

    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {

      this.options.min = this.moment(this.from).subtract(1, 'hour');
      this.options.max = this.moment(this.to).add(1, 'hour');
      this.timeline.setOptions(this.options);
    }

    if (changes.doFit && !changes.doFit.isFirstChange()) {
      if (this.doFit) {
        this.onFit();
      }
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onFit() {
    this.$timeout(0).then(() => {
      this.timeline.fit();
    })
  }

  onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _addItinerariesToTimeline(itineraries) {

    // Make sure the itineraries doesnt exist in timeline before adding them.
    const currentItineraryIdsInTimeline = this.groupsDataSet.getIds();
    const itinerariesToAdd = _.filter(itineraries, (itinerary) => {
      return !_.includes(currentItineraryIdsInTimeline, itinerary.id);
    })

    var groups = this._mapItinerariesToGroups(itinerariesToAdd);
    this.groupsDataSet.add(groups);

    this._addItinerariesTasksToTimeline(itineraries);

  }

  private _addItinerariesTasksToTimeline(itineraries) {
    // var tasks = _.flatMap(itineraries, 'taskListExt');
    const tasksIds = _.flatMap(itineraries, 'taskIdListExt');
    let tasks = _.filter(this.tasks, (t) => {
      return _.includes(tasksIds, t.id);
    });

    tasks = _.sortBy(tasks, function (t) {
      return tasksIds.indexOf(t.id)
    })

    const activityItems = this._getItemsData(tasks);
    const backgroundItems: any = this._mapItinerariesToBackgroundItems(itineraries);
    this.itemsDataSet.add(_.concat(activityItems, backgroundItems));
  }

  private _mapItinerariesToGroups(itineraries) {
    return _.map(itineraries, (itinerary) => {
      return this._getGroupData(itinerary);
    });
  }

  private _getGroupData(itinerary) {
    return {
      id: itinerary.id,
      name: this.$filter('userName')(itinerary.agent.user),
      nameInitials: this.$filter('userInitials')(itinerary.agent.user),
      imageUrl: itinerary.agent.user.avatarUrl,
      agentType: itinerary.agent.agentType,
      taskIdList: itinerary.taskIdList,
      taskIdListExt: itinerary.taskIdListExt
    };
  }

  private _getItemsData(tasks) {
    return _.map(tasks, (task, index) => {
      const purpose = task.taskSpec.purpose;
      const isBundle = _.isEqual(task.taskType, 'BundledStopover');
      const isInternal = _.isEqual(task.taskType, 'Internal') ||
        (_.isEqual(task.taskType, 'BundledStopover') && _.includes(this.INTERNAL_TASK_PURPOSE, purpose));

      const relations = _.get(task, 'relations', []);
      const isCompleted = _.isEqual(task.status, 'CourierDeparted');
      const isCanceled = _.isEqual(task.status, 'Canceled');
      const defaultServiceTime = 300000;
      const taskServiceTime = _.get(task, 'analysis.serviceTime') > defaultServiceTime ?
        _.get(task, 'analysis.serviceTime') :
        defaultServiceTime;
      const taskEta = isCompleted ? _.get(task, 'agentDepartureTime') : (isCanceled ? _.get(task, 'agentArrivalTime') : _.get(task, 'analysis.eta'));
      const taskEtd = isInternal ? (taskEta + taskServiceTime) : _.get(task, 'analysis.etd') || (taskEta + taskServiceTime);
      const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});
      let taskClass = isInternal ? 'internal' : (isBundle ? 'bundle' : 'task');
      taskClass += ' ' + purpose;
      const color = this.TASK_PURPOSE_TO_COLOR_MAP[purpose];


      return {
        id: task.id,
        serviceId: task.serviceId,
        serviceIds: task.bundleServiceIdList,
        start: this.moment(taskEta),
        end: this.moment(taskEtd),
        group: task.agentId,
        bundleTasks: _.get(task, 'bundledTaskList', []), // For Bundle Only
        purpose: purpose,
        // relatedRoutes: relatedRoutes || [],
        // relatedStops: relatedStops || [],
        // warnings: warnings || [],
        point: 'box',
        title: this.bringozTimelineService.getTaskExtendedTimelineItemTooltip(task, taskEtaWindow, undefined),
        content: isInternal ? this.bringozTimelineService.getInternalItemContent(task, true) :
          (!isBundle ?
            this.bringozTimelineService.getTaskTimelineItemContent(task, relations, true) :
            this.bringozTimelineService.getBundleTaskTimelineItemContent(task, relations, true)),
        style: 'background-color: ' + color + '; color: white',
        // style: isStop ? 'color: '+ color : 'background-color: ' + color,
        className: taskClass
        // style: 'border-color: ' + (route.color || 'black') + ';' + 'background-color: white;'
      }
    })
  }

  private _mapItinerariesToBackgroundItems(itineraries) {
    return _.chain(itineraries)
      .filter((itinerary) => {
        itinerary.firstTaskRef = _.find(this.tasks, (t) => {
          return _.get(itinerary, 'taskIdListExt[0]') === t.id;
        });
        itinerary.lastTaskRef = _.find(this.tasks, (t) => {
          return !!itinerary.taskIdListExt &&
            itinerary.taskIdListExt[_.get(itinerary, 'taskIdListExt.length', 1) - 1] === t.id;
        });
        return !!_.get(itinerary, 'taskIdListExt.length') &&
          (_.get(itinerary.firstTaskRef, 'analysis.eta') && _.get(itinerary.lastTaskRef, 'analysis.eta'));
      })
      .flatMap((filteredItinerary) => {
        return {
          id: filteredItinerary.id,
          start: _.get(filteredItinerary.firstTaskRef, 'analysis.eta') ? this.moment(filteredItinerary.firstTaskRef.analysis.eta) : undefined,
          end: _.get(filteredItinerary.lastTaskRef, 'analysis.eta') ? this.moment(filteredItinerary.lastTaskRef.analysis.eta) : undefined,
          group: filteredItinerary.id,
          type: 'background'
        }
      })
      .value()
  }

  private _clearTimelineData() {
    this.groupsDataSet.clear();
    this.itemsDataSet.clear();
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTimelineGroupById(id) {

    if (!id) {
      return undefined;
    }

    const selectedGroup = this.groupsDataSet.get({
      filter: (group) => {
        return group.id === id;
      }
    });
    return this.itemsDataSet.get(selectedGroup[0] ? selectedGroup[0].id : undefined)
  }

  private _getTimelineTaskById(id) {

    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: function (item) {
        return item.id === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  // function _canItemMove(item) {
  //
  //     var movingToRoute = _.find(ctrl.routes, function(r) {
  //         return r.id === item.group;
  //     })
  //
  //     if (!item.stopId || (item.activityType === 'GROUP' && !item.stopIds.length)) {
  //         return false;
  //     }
  //
  //     if (movingToRoute) {
  //         var resourceSkills = _.get(movingToRoute, 'resource.allocationSkills', []);
  //         var itemSkill = item.purpose === 'Operation' ? 'Merchandise' : 'Delivery';
  //         if (!_.includes(resourceSkills, itemSkill)) {
  //             var stopType = $filter('translate')('SKILLS.' + itemSkill);
  //             var routeType = $filter('translate')('SKILLS.' + resourceSkills[0]);
  //             PlanningAlerts.stopTypeToRouteRejectionInfo(stopType, routeType);
  //             return false;
  //         }
  //     }
  //
  //     var orderedItems = timeline.components[3].groups[item.group].orderedItems.byStart;
  //
  //     var itemPurpose = item.purpose;
  //     var itemIndex = _.findIndex(orderedItems, function(orderedItem) {
  //         return orderedItem.data.activityId === item.activityId;
  //     });
  //
  //
  //     if (_.isEqual(movedItemOriginalData.group, item.group) &&
  //         _.isEqual(movedItemOriginalData.index, itemIndex)) {
  //         return false;
  //     }
  //
  //
  //     var parallelIndex = _.findIndex(orderedItems, function(task) {
  //         return task.parentId === item.parentId;
  //     });
  //     if (!parallelIndex) {
  //         return true;
  //     } else {
  //         return itemPurpose === 'Pickup' ? (itemIndex < parallelIndex) : (parallelIndex < itemIndex);
  //     }
  // }

  private _initTimelineEventListeners() {

    /////////////////////
    // Timeline Events //
    /////////////////////

    // Hover
    this.timeline.on('mouseOver', (props) => {
      this._onClicked().then(() => {
        this.onTaskHighlight({task: this._getTimelineTaskById(_.get(props, 'item')), $event: _.get(props, 'event')});
      });
    });

    // On Item Click
    this.timeline.on('select', (properties) => {
      this._onClicked().then(() => {
        const selectedTask = this._getTimelineTaskById(properties.items[0]);
        this.onTaskSelection({serviceId: _.get(selectedTask, 'serviceId'), taskId: _.get(selectedTask, 'id')});
      });
    });


  }

  $onDestroy() {
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }
}

angular
  .module('bringoz.admin.itineraries')
  .component('itinerariesTimeline', {
    bindings: {
      from: '<',
      to: '<',
      itineraries: '<',
      tasks: '<',
      agentsGroup: '<',
      selectedItemId: '<',
      highlightedItemId: '<',
      canEdit: '<',
      doFit: '<?',
      onTaskSelection: '&',
      onTaskHighlight: '&',
      onTaskRightClick: '&',
      onChangeItinerary: '&',
      onAgentsGroupChange: '&'
    },
    template: require('./itineraries-timeline.html').default,
    controller: ItinerariesTimelineCtrl
  });
